import apiClient from "../../../../../../services/apiClient";


export const invitesStatisticsActions = {
  getInvitesAll: async (district) => {
    let params = [];
    
    if (district !== 'all') {
      params.push('distr=' + district);
    }
    
    const linkGet = params.length === 0 
      ? 'requests/invites_all' 
      : '/requests/invites_all?' + params.join('&');

    return await apiClient.get(linkGet);
  }
};